import { loadingSpinnerActions } from "../../actions/loadingSpinnerActions";
var OrdersReduxProps = {
    mapDispatchToProps: function (dispatch) {
        return {
            onShowSpinner: function () { return dispatch({ type: loadingSpinnerActions.SHOW_SPINNER_MODAL }); },
            onHideSpinner: function () { return dispatch({ type: loadingSpinnerActions.HIDE_SPINNER_MODAL }); },
        };
    }
};
export default OrdersReduxProps;



//////////////////
// WEBPACK FOOTER
// ./src/views/Orders/OrdersReduxProps.ts
// module id = 395
// module chunks = 0